import { ptBR } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import moment from "moment";
import { InputDate, CalendarBox, Calendar } from "../styles";
import { InputIcon } from "../InputIcon";
import { dateFormatedToDB } from "../../../../../services/functions";

// O calendario cobre de cinco anos atras a dois a frente: historico de loja
// nao passa disso e uma lista aberta demais vira rolagem infinita no seletor.
const ANO_ATUAL = new Date().getFullYear();
const PRIMEIRO_ANO = ANO_ATUAL - 5;
const ULTIMO_ANO = ANO_ATUAL + 2;

export function InputTypeDate({ value, onChange = () => null, ...rest }) {
  const dataSelecionada = value ? new Date(`${dateFormatedToDB(value)} 00:00:00`) : undefined;
  const dataValida =
    dataSelecionada && !Number.isNaN(dataSelecionada.getTime()) ? dataSelecionada : undefined;

  return (
    <>
      <InputDate {...rest} placeholder=" " value={value} readOnly />
      <InputIcon Icon={CalendarDays} />
      <CalendarBox>
        <Calendar
          mode="single"
          selected={dataValida}
          defaultMonth={dataValida}
          /* mes e ano viram seletores: antes so existiam as setas, e voltar um
             ano no historico custava doze cliques */
          captionLayout="dropdown-buttons"
          fromYear={PRIMEIRO_ANO}
          toYear={ULTIMO_ANO}
          onSelect={(date) => {
            if (!date) return;
            onChange(moment(date).format("DD/MM/YYYY"));
            // o calendario e aberto por :focus-within; sem tirar o foco ele
            // continuaria aberto por cima da tela depois da escolha
            if (document.activeElement?.blur) document.activeElement.blur();
          }}
          locale={ptBR}
        />
      </CalendarBox>
    </>
  );
}
